import { render, staticRenderFns } from "./MainAddressCardView.vue?vue&type=template&id=3dfd60df&"
import script from "./MainAddressCardView.vue?vue&type=script&lang=js&"
export * from "./MainAddressCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports